import { FC } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { EndSessionButton } from 'components/Header/HeaderUserDrop/EndSessionButton/EndSessionButton';
import { LogoutButton } from 'components/Header/HeaderUserDrop/LogoutButton/LogoutButton';
import { Logo } from 'components/Logo/Logo';

import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

import styles from 'components/Admin/AdminHeader/AdminHeader.module.less';

const TrlKeys = {
    title: 'admin.title',
    [SessionType.Typical]: 'admin.Users.Session.typical',
    [SessionType.Sudo]: 'admin.Users.Session.sudo',
};

export const AdminHeader: FC = () => {
    const { user, sessionType } = useSelector((state) => state.user);
    const isSudo = sessionType === SessionType.Sudo;

    const trls = useTrls();

    return (
        <header className={styles.adminHeaderWrapper}>
            <div className={styles.adminHeader}>
                <Logo />
                <Text typography="title-4-semibold" style="constant">
                    {trls(TrlKeys.title)}
                </Text>
                <div className={styles.adminHeaderGroup} data-qa="admin-info-user">
                    <div className={styles.adminHeaderInfoUser}>
                        <Text typography="subtitle-2-semibold" style="constant" data-qa="admin-info-user-name">
                            {user?.name}
                        </Text>
                        <Text typography="label-3-regular" style="constant-secondary" data-qa="admin-info-user-type">
                            {trls(TrlKeys[sessionType])}
                        </Text>
                    </div>
                    {isSudo ? <EndSessionButton isAdminHeader /> : <LogoutButton isAdminHeader />}
                </div>
            </div>
        </header>
    );
};
